var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChecklistChecked = function SvgChecklistChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#02A1E5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.337 7.43a.63.63 0 0 1 .924-.055c.27.254.292.689.051.972l-6.696 7.847a.633.633 0 0 1-.95.028l-3.074-3.234a.714.714 0 0 1 0-.973.63.63 0 0 1 .925 0l2.585 2.719z"
  }))));
};
export default SvgChecklistChecked;